import React, { forwardRef, useImperativeHandle, useState } from "react";
import PopupModal, { PopupModalRef } from "components/common/PopupModal";
import NotComeBooking from "./BookingCard/NotComeBooking";
import DoneBooking from "./BookingCard/DoneBooking";
import ButtonGroup from "components/common/ButtonGroup";
import Button from "components/common/Button";

export interface MoreActionsModalRef {
  open: (booking: any) => void;
  close: () => void;
}

interface MoreActionsModalProps {
  onSuccess?: (res?: any) => void;
}

const MoreActionsModal = forwardRef<MoreActionsModalRef, MoreActionsModalProps>(
  ({ onSuccess }, ref) => {
    const [visible, setVisible] = useState(false);
    const [currentBooking, setCurrentBooking] = useState<any>(null);

    useImperativeHandle(ref, () => ({
      open: (booking: any) => {
        setCurrentBooking(booking);
        setVisible(true);
      },
      close: () => {
        setVisible(false);
        setCurrentBooking(null);
      },
    }));

    if (!visible || !currentBooking) {
      return null;
    }

    const handleSuccess = (res?: any) => {
      setVisible(false);
      onSuccess?.(res);
    };

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setVisible(false)}
        />
        <div className="relative bg-white rounded-lg p-6 max-w-sm w-full mx-4">
          <h3 className="text-lg font-semibold text-center mb-6">
            Chọn hành động
          </h3>
          <ButtonGroup vertical fullWidth spacing="md" className="mb-4">
            <DoneBooking
              booking={currentBooking}
              onSuccess={handleSuccess}
              className="w-full"
            />
            <NotComeBooking
              booking={currentBooking}
              onSuccess={handleSuccess}
              className="w-full"
            />
          </ButtonGroup>
          <Button
            variant="ghost"
            fullWidth
            onClick={() => setVisible(false)}
          >
            Đóng
          </Button>
        </div>
      </div>
    );
  }
);

MoreActionsModal.displayName = "MoreActionsModal";

export default MoreActionsModal;